import React from 'react'
import NumberFormat from 'react-number-format'
import PropTypes from 'prop-types'
import Input from 'src/Components/Input'

const propTypes = {
  className: PropTypes.string
}

const defaultProps = {}

const NumberInput = ({ onChange, onChangeValues, ...restProps }) => (
  <NumberFormat
    customInput={Input}
    onValueChange={values => {
      if (onChange) {
        onChange({
          target: {
            value: values.value
          }
        })
      }

      if (onChangeValues) {
        onChangeValues(values)
      }
    }}
    {...restProps}
  />
)

NumberInput.propTypes = propTypes
NumberInput.defaultProps = defaultProps

export default NumberInput
